import React from "react";

const ModifierTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">NASCAR WHELEN MODIFIED TOUR PAGE</h2>
        <p className='pb-1 lh-base' data-aos="fade-up" data-aos-delay="100">This series was known as the Winston Modified Tour from 1985 to 1993 and as the Featherlite Modified Tour from 1994 to 2004.</p>
       
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
              <tr style={{ width: "100%" }}>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Races
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                Champion
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                Rookie of the Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "20%" }}>
                Most Popular Driver
                </th>
          
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Melissa Fifield</td>
            
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}></td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Ryan Preece</td>
          
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}></td>
           
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Tony Hirschman</td>
    
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Rick Fuller</td>
            </tr>
            <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Melissa Fifield</td>
            
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}></td>
                </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Ryan Preece</td>
          
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}></td>
           
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Tony Hirschman</td>
    
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Rick Fuller</td>
            </tr>
          
            </tbody>
          </table>
      
       
        </div>
      </section>
    </>
  );
};

export default ModifierTable;
